<script>
  import StockTakeModal from "./StockTakeModal.svelte";
  import Select from "svelte-select";
  import Layout from "../../Layout/Layout.svelte";
  import config from "../../stores/config";
  import axios from "axios";
  import { onMount } from "svelte";
  import ItemRow from "./ItemRow.svelte";
  import { Wave } from "svelte-loading-spinners";
  import { link } from "svelte-spa-router";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import ItemHeader from "./ItemHeader.svelte";

  let products = null;
  let queryURL = "";

  /* Query Parameters, just CHANGE them and the query will be regenerated as well, NO need to change everything */
  let currentClass_;
  let page = 1;
  let searchKey = "";

  const fetchProducts = () => {
    products = null;

    queryURL = `${$config.backendURL}/items/page/${page}?`;
    queryURL += `&searchKey=${searchKey || ""}`;
    queryURL += `&class_=${currentClass_?.value}`;

    axios
      .get(queryURL)
      .then((res) => {
        products = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchProducts();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchProducts();
  };

  const handleRefresh = () => {
    page = 1;
    searchKey = "";
    fetchProducts();
  };

  onMount(() => {
    fetchProducts();
  });

  const handlePrintCSV = async () => {
    let res = await axios.get(`${$config.backendURL}/items`);

    let custExport = res.data.map(
      ({
        addedBy,
        addedOn,
        // _id,
        __v,
        reorderLevel,
        supplierID,
        flux,
        class_,
        ...rest
      }) => rest
    );

    let rows = [];

    // Get headers
    let rowsHeaders = [];
    for (const field in custExport[0]) {
      rowsHeaders.push(
        field.replace(/([A-Z])/g, " $1").replace(/^./, (str) => {
          return str.toUpperCase();
        })
      );
    }

    rows.push(rowsHeaders);

    // Get body
    custExport.forEach((el) => {
      let rowsBody = [];
      let K, plankPrice, totalMM;

      for (const field in el) {
        if (field == "price" && el.lotNumber) {
          K = $config.K.find((x) => x._id == el.lotNumber)?.total;

          totalMM = el?.length * el?.width * el?.thickness;

          plankPrice = Number((totalMM / K) * el?.bundlePrice)?.toFixed(2);

          rowsBody.push(plankPrice || "N/A");
        } else {
          rowsBody.push(el[field] || "N/A");
        }
      }

      rows.push(rowsBody);
    });

    // Ready CSV Up
    let csvContent =
      "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");

    // Export CSV
    let encodedUri = encodeURI(csvContent);
    window.open(encodedUri);
  };

  let showSTakeModal = false;
</script>

<svelte:head>
  <title>Raw Materials — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  {#if $config.currentUser}
    {#if $config.currentUser.department == "Management"}
      <MenuHeading
        title="Raw Materials"
        description="Manage the Raw Materials"
      />

      <!-- Search Bar -->
      <div class="flex justify-between">
        <div class="flex justify-center">
          <input
            bind:value={searchKey}
            on:input={fetchProducts}
            class="shadow-sm"
            type="text"
            placeholder="Enter an item name..."
          />
          <button class="ml-2 btn btn-primary" on:click={fetchProducts}>
            <i class="fas fa-search" />
          </button>
        </div>

        <div class="w-64">
          <Select
            items={$config.itemC}
            on:select={(e) => {
              currentClass_ = e.detail;
              fetchProducts();
            }}
            placeholder="💡 Select a category"
          />
        </div>

        <div class="flex items-center">
          <button class="btn btn-green mr-2" on:click={handlePrintCSV}>
            <i class="fas fa-save mr-2" />
            Export
          </button>
          <button class="btn btn-green mr-2" on:click={handleRefresh}>
            <i class="fas fa-undo mr-2" />
            Reload
          </button>
          <button
            class="btn btn-primary mr-2"
            on:click={() => (showSTakeModal = true)}
          >
            <i class="fas fa-folder-open mr-2" />
            Stock Take
          </button>
          <a class="btn btn-primary" use:link href="/addproduct">
            <i class="fas fa-plus-circle mr-2" />
            Add item
          </a>
        </div>
      </div>

      <!-- Products Bar -->
      <div
        class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
      >
        {#if currentClass_}
          <ItemHeader class_={currentClass_?.value} />

          {#if products}
            {#each products as prod (prod._id)}
              <ItemRow {...prod} on:delete={fetchProducts} />
            {:else}
              <div class="h-52 w-full flex items-center justify-center">
                Nothing to show...
              </div>
            {/each}
          {:else}
            <div class="h-52 w-full flex items-center justify-center">
              <Wave size="50" color="rgb(244,162,97)" unit="px" />
            </div>
          {/if}

          <div class="tf">
            <button
              class="text-base btn btn-gray-outline"
              on:click={handlePrevPage}
            >
              <i class="fas fa-arrow-alt-circle-left mr-3" />
              Prev Page
            </button>
            <div class="mx-4">Page {page}</div>
            <button
              class="text-base btn btn-gray-outline"
              on:click={handleNextPage}
            >
              Next Page
              <i class="fas fa-arrow-alt-circle-right ml-3" />
            </button>
          </div>
        {:else}
          <div class="flex items-center justify-center h-80">
            💡 Select a Category to display items
          </div>
        {/if}
      </div>
    {/if}
  {/if}
</Layout>

{#key showSTakeModal}
  <StockTakeModal
    on:modalClose={() => (showSTakeModal = false)}
    show={showSTakeModal}
  />
{/key}

<style>
  .th,
  .tf {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
